import { call, put, select, takeLatest } from 'redux-saga/effects';
import { GET_APP_CONFIGS, GET_SITEMAP_DATA } from '../constants';
import { StatusCodes } from 'http-status-codes';
import { getAppConfigsError, getAppConfigsSuccess, getAppConfigsSuccessNoUpdate, getSitemapDataSuccess, getSitemapDataError, } from '../redux/Actions/AppConfigsActions';
import networkConfig from '../network/config';
import invokeApi from '../network';
import { v4 as uuidv4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';
import { setErrorCode } from '../redux/Actions/ErrorAction';
const { OK, CREATED, NOT_MODIFIED } = StatusCodes;
const isOK = (result) => {
    return result?.response && (result?.status === OK || result?.status === CREATED || result?.status === NOT_MODIFIED);
};
export function* checkHttpErrors(result) {
    if (!isOK(result)) {
        const { status, response } = result;
        yield put(setErrorCode(status));
        throw new Error(response);
    }
}
export const appConfigsReducerSelector = (state) => {
    return state?.appConfigsReducer;
};
export function* getAppConfigs(action) {
    const { payload: { tenantCode } = {} } = action;
    let { response: { lastUpdated = -1 } = {}, clientId } = yield select(appConfigsReducerSelector) ?? {};
    const updated = lastUpdated === -1 ? lastUpdated : Math.floor(lastUpdated / 1000);
    const configData = {
        queryProps: { tenantCode, lastUpdated: updated },
    };
    if (isEmpty(clientId)) {
        clientId = uuidv4();
    }
    const header = {
        'x-client-id': clientId,
    };
    try {
        const result = yield call(invokeApi, networkConfig.appConfigs, configData, header);
        yield* checkHttpErrors(result);
        if (result.status === NOT_MODIFIED) {
            yield put(getAppConfigsSuccessNoUpdate());
        }
        else {
            yield put(getAppConfigsSuccess({ response: result?.response, clientId }));
        }
    }
    catch (error) {
        yield put(getAppConfigsError());
    }
}
export function* appConfigsSaga() {
    yield takeLatest(GET_APP_CONFIGS, getAppConfigs);
}
export function* getSitemapData(action) {
    try {
        const result = yield call(invokeApi, networkConfig.sitemapData);
        yield* checkHttpErrors(result);
        yield put(getSitemapDataSuccess({ sitemapData: result?.response }));
    }
    catch (error) {
        yield put(getSitemapDataError());
    }
}
export function* sitemapDataSaga() {
    yield takeLatest(GET_SITEMAP_DATA, getSitemapData);
}
